(ns common.i18n.lang.es
  (:require [common.i18n.icu :as icu]
            [common.i18n.inst-fmt :as inst-fmt]))

(def inst-strings
  { :weekdays-narrow ["D" "L" "M" "M" "J" "V" "S"]
    :weekdays-short  ["Dom" "Lun" "Mar" "Mié" "Jue" "Vie" "Sáb"]
    :weekdays-long   ["Domingo" "Lunes" "Martes" "Miércoles" "Jueves" "Viernes" "Sábado"]
    :months-narrow   ["E" "F" "M" "A" "M" "J" "J" "A" "S" "O" "N" "D"]
    :months-short    ["Ene" "Feb" "Mar" "Abr" "May" "Jun" "Jul" "Ago" "Sep" "Oct" "Nov" "Dic"]
    :months-long     ["Enero" "Febrero" "Marzo" "Abril" "Mayo" "Junio" "Julio" "Agosto" "Septiembre" "Octubre" "Noviembre" "Diciembre"]
;;    :dayperiods      ["am" "pm"] 24-hour time format is normally used in Spanish language
    :eras-short      ["AC" "DC"]
    :eras-long       ["Antes de Cristo" "Después de Cristo"] })

(def inst-fmt (partial inst-fmt/tongue-inst-formatter inst-strings))

(def dictionary
  {:dictionary.common/file-type-time-string
   (icu/msg
    "{fileType, select, pdf {{timeString} leer} video {{timeString} } audio {{timeString} escuchar} other {}}"),
   :dictionary.common/time-string
   (icu/msg
    "{hours, plural, =0 {{minutes, plural, =0 {{seconds, plural, other {# seg}}} other {# min}}} other {# h{minutes, plural, =0 {} other { y # min}}}}."),
   :kyber.components.composite.brand-footer/arcx "ArcheMedX",
   :kyber.components.composite.brand-footer/powered-by
   "Desarrollado por",
   :kyber.components.composite.brand-footer/privacy-policy
   "Política de Privacidad",
   :kyber.components.composite.brand-footer/terms-conditions
   "Términos y Condiciones",
   :kyber.components.composite.dropdown-menu/aria-label
   "Menú de la aplicación",
   :kyber.components.composite.footer/arcx " ArcheMedX",
   :kyber.components.composite.footer/copyright "© {1}",
   :kyber.components.composite.footer/privacy "Política de Privacidad",
   :kyber.components.composite.footer/rights-reserved
   ", todos los derechos reservados.",
   :kyber.components.composite.footer/support "Equipo de soporte",
   :kyber.components.composite.footer/terms "Términos y Condiciones",
   :kyber.components.composite.gdpr/form-message
   (icu/msg
    "Al {context, select, signIn {iniciar sesión} signUp {registrarse} other {continuar}}, reconoce que comprende y acepta el siguiente documento de ArcheMedX "),
   :kyber.components.composite.gdpr/link "Política de Privacidad",
   :kyber.components.composite.gdpr-splash/disclaimer
   "Al continuar, reconoce que comprende y acepta la ",
   :kyber.components.composite.gdpr-splash/policy
   "Política de privacidad de ArcheMedX",
   :kyber.components.composite.group-readiness-composition-chart/high-readiness
   "Disponibilidad alta",
   :kyber.components.composite.group-readiness-composition-chart/incompleters
   "Incompletadores*",
   :kyber.components.composite.group-readiness-composition-chart/low-readiness
   "Disponibilidad baja",
   :kyber.components.composite.group-readiness-composition-chart/med-readiness
   "Disponibilidad media",
   :kyber.components.composite.group-readiness-composition-chart/no-performance-data
   "Sin datos de rendimiento",
   :kyber.components.composite.hr-manager-card-group/full-name
   "{given-name} {family-name}",
   :kyber.components.composite.hr-manager-card-group/incompleters
   "*“Incompletadores” ",
   :kyber.components.composite.hr-manager-card-group/incompleters-desc
   "son alumnos que comenzaron una actividad, pero aún no la completaron.",
   :kyber.components.composite.hr-manager-card-group/indirect-reports
   "Los subordinados indirectos son la suma de todos los subordinados directos e indirectos de todo gerente que responde ante ",
   :kyber.components.composite.hr-manager-card-group/manager "Gerente",
   :kyber.components.composite.hr-manager-card-group/report-to-list
   "Esta es una lista de gerentes que responden ante ",
   :kyber.components.composite.hr-manager-card-group/reporting-managers
   "Gerentes subordinados",
   :kyber.components.composite.media-player/audio-file-header
   "Archivo de audio",
   :kyber.components.composite.passwordless-sign-in/access-this
   "acceder a este {1}",
   :kyber.components.composite.passwordless-sign-in/check-email
   "Verifique su correo electrónico.",
   :kyber.components.composite.passwordless-sign-in/different-button
   "Enviar a uno correo electrónico distinto",
   :kyber.components.composite.passwordless-sign-in/enter-email-to
   "Escriba su correo electrónico para {1}",
   :kyber.components.composite.passwordless-sign-in/give-access
   "darle acceso a este {1}",
   :kyber.components.composite.passwordless-sign-in/has-link
   "Contiene un vínculo que {1}.",
   :kyber.components.composite.passwordless-sign-in/link-expired
   "El vínculo expiró. ",
   :kyber.components.composite.passwordless-sign-in/no-email
   "¿No recibió el correo electrónico? ",
   :kyber.components.composite.passwordless-sign-in/resend-button
   "reenviar",
   :kyber.components.composite.passwordless-sign-in/sent-to
   "Enviamos un correo electrónico a {1}.",
   :kyber.components.composite.passwordless-sign-in/sign-in
   "iniciar sesión",
   :kyber.components.composite.passwordless-sign-in/sign-you-in
   "iniciarle sesión",
   :kyber.components.composite.passwordless-sign-in/wrong-email
   "¿Correo electrónico incorrecto? ",
   :kyber.components.composite.pdf-viewer/search-placeholder
   "Buscar documento",
   :kyber.components.composite.pdf-viewer/search-result-counter
   "{1} de {2}",
   :kyber.components.composite.pdf-viewer/search-result-none
   "Sin resultados",
   :kyber.components.composite.rate/rate-label
   (icu/msg "{rate, select, 075 {0,75X} 1 {1X} 125 {1,25X} other{}}"),
   :kyber.components.composite.videojs-player/no-support
   "Para ver este video, active JavaScript y considere la posibilidad de actualizar a un navegador web ",
   :kyber.components.composite.videojs-player/no-support-link
   "compatible con video HTML5",
   :kyber.components.form-fields.select/add-select-option-display
   "Seleccione una opción",
   :kyber.components.forms.free-form-question/best-practices
   "Prácticas recomendadas",
   :kyber.components.forms.free-form-question/body
   "Lorem ipsum dolor sit amet, consectetur adipiscing do eiusmod tempor incididunt ut labore et dolore aliqua. Ut enim ad minim veniam, quis nostrud exercitation.",
   :kyber.components.forms.free-form-question/cancel "cancelar",
   :kyber.components.forms.free-form-question/default-text "Enviar",
   :kyber.components.forms.free-form-question/error
   "Corrija los errores de la izquierda.",
   :kyber.components.forms.free-form-question/header
   "Agregue una pregunta de texto libre:",
   :kyber.components.forms.free-form-question/placeholder
   "Escriba la pregunta",
   :kyber.components.forms.free-form-question/required "Obligatorio",
   :kyber.components.forms.inline-field-form/confirm-text "Quitar",
   :kyber.components.forms.inline-field-form/deny-text "Mantener",
   :kyber.components.forms.inline-field-form/loading-label
   "actualizando…",
   :kyber.components.forms.inline-field-form/no-value-label
   "No se fijó ningún valor",
   :kyber.components.forms.multi-answer-question/best-practices-copy
   "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.",
   :kyber.components.forms.multi-answer-question/card-title
   "Agregue una nueva pregunta de respuesta múltiple:",
   :kyber.components.forms.multi-answer-question/validator-max
   "Le recomendamos que tenga un máximo de 5 respuestas.",
   :kyber.components.forms.multi-answer-question/validator-min
   "Le recomendamos que tenga más de 2 respuestas.",
   :kyber.components.forms.multi-answer-question/validator-required
   "Se requieren al menos 2 respuestas",
   :kyber.components.forms.multiple-choice-question-base/answer-placeholder
   "Escriba la respuesta",
   :kyber.components.forms.multiple-choice-question-base/best-practices
   "Prácticas recomendadas",
   :kyber.components.forms.multiple-choice-question-base/cancel
   "cancelar",
   :kyber.components.forms.multiple-choice-question-base/other-option-label
   "¿Incluir otra opción?",
   :kyber.components.forms.multiple-choice-question-base/question-placeholder
   "Escriba la pregunta",
   :kyber.components.forms.multiple-choice-question-base/question-validator-required
   "Obligatorio",
   :kyber.components.forms.multiple-choice-question-base/submit "Enviar",
   :kyber.components.forms.multiple-choice-question-base/submit-error
   "Corrija los errores de la izquierda.",
   :kyber.components.forms.multiple-choice-question-base/validator-required
   "Obligatorio",
   :kyber.components.forms.passwordless-sign-in/label
   "Correo electrónico",
   :kyber.components.forms.passwordless-sign-in/submit "Enviar",
   :kyber.components.forms.passwordless-sign-in/validator-invalid
   "Dirección de correo electrónico no válida",
   :kyber.components.forms.passwordless-sign-in/validator-required
   "Obligatorio",
   :kyber.components.forms.single-answer-question/best-practices-copy
   "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.",
   :kyber.components.forms.single-answer-question/card-title
   "Agregue una nueva pregunta de respuesta única:",
   :kyber.components.forms.single-answer-question/max-answers
   "Le recomendamos que tenga un máximo de 5 respuestas.",
   :kyber.components.forms.single-answer-question/min-answer
   "Le recomendamos que tenga más de 2 respuestas.",
   :kyber.components.forms.single-answer-question/required
   "Se requieren al menos 2 respuestas",
   :kyber.components.forms.user-profile/family-name-label "Apellido",
   :kyber.components.forms.user-profile/given-name-label "Nombre",
   :kyber.components.forms.user-profile/submit "Guardar cambios",
   :kyber.components.forms.user-profile/validator-family-name
   "Obligatorio",
   :kyber.components.forms.user-profile/validator-given-name
   "Obligatorio",
   :kyber.containers.privacy-policy/about-pixels
   "También podemos utilizar etiquetas de píxel (también conocidas como “balizas web” y “GIF transparentes”) en nuestro sitio o a través de comunicaciones por correo electrónico de terceros para realizar un seguimiento de las acciones de los usuarios en nuestro sitio. A diferencia de las cookies, que un sitio web almacena en el disco duro de su computadora o dispositivo móvil, las etiquetas de píxel se incrustan de forma invisible en las páginas web. Las etiquetas de píxel miden el éxito de nuestras comunicaciones y recopilan estadísticas sobre el uso del sitio, para que podamos gestionar nuestro contenido con mayor eficacia. La información que recopilamos mediante etiquetas de píxel no está vinculada a los datos personales de nuestros usuarios.",
   :kyber.containers.privacy-policy/addr-1 "300 E Main St Suite 101",
   :kyber.containers.privacy-policy/addr-2 "Charlottesville, VA 22902 ",
   :kyber.containers.privacy-policy/addr-3
   "Correo electrónico: info@archemedx.com",
   :kyber.containers.privacy-policy/addr-4 "Teléfono: 434-260-1850",
   :kyber.containers.privacy-policy/an-emergency
   "en una emergencia. Esto incluye proteger la seguridad de nuestros empleados y agentes, nuestros clientes o cualquier persona. Con los que lo necesitan para trabajar por nosotros.",
   :kyber.containers.privacy-policy/automatic-collection
   "Información recopilada automáticamente",
   :kyber.containers.privacy-policy/automatic-stuff
   "Registramos automáticamente información sobre usted y su computadora. Por ejemplo, cuando visita nuestro sitio y nuestras aplicaciones, registramos el tipo de sistema operativo de su computadora, el tipo de navegador, el idioma del navegador, el sitio web que visitó antes de entrar en nuestro sitio, las páginas que visitó, el tiempo que pasó en una página, las horas de acceso e información sobre su uso y sus acciones en nuestro sitio.",
   :kyber.containers.privacy-policy/business-deal
   "Cuando realicemos o negociemos una operación comercial que implique la venta o transferencia de la totalidad o esencialmente la totalidad de nuestras actividades o activos. Estas operaciones pueden incluir cualquier fusión, financiación, adquisición o transacción o procedimiento concursal.",
   :kyber.containers.privacy-policy/by-visiting
   "Al visitar nuestro sitio y facilitarnos sus datos personales, usted reconoce y acepta que sus datos personales puedan ser tratados para los fines identificados en esta Política.",
   :kyber.containers.privacy-policy/changes-to-policy
   "MODIFICACIONES DE ESTA POLÍTICA",
   :kyber.containers.privacy-policy/children "NIÑOS",
   :kyber.containers.privacy-policy/contact-info
   "QUIÉNES SOMOS E INFORMACIÓN DE CONTACTO",
   :kyber.containers.privacy-policy/contact-us
   "Agradeceremos sus comentarios sobre esta Política. Si tiene alguna pregunta sobre cómo utilizamos sus datos personales o desea que los eliminemos, no dude en ponerse en contacto con nosotros a:",
   :kyber.containers.privacy-policy/cookie-categories
   "Existen dos grandes categorías de cookies:",
   :kyber.containers.privacy-policy/cookie-def
   "Las cookies son archivos de texto que contienen pequeñas cantidades de información que se descargan en su computadora o dispositivo móvil cuando visita un sitio web o una aplicación móvil. Las cookies se envían de vuelta al sitio de origen en cada visita posterior, o a otro sitio que las reconozca. Puede obtener más información sobre las cookies en www.allaboutcookies.org.",
   :kyber.containers.privacy-policy/cookie-enhancers
   "Utilizamos cookies para mejorar la experiencia en línea de nuestros visitantes (por ejemplo, recordando sus preferencias de idioma o productos) y para comprender mejor cómo se utiliza nuestro sitio. Las cookies pueden indicarnos, por ejemplo, si ya visitó nuestro sitio anteriormente o si es un nuevo visitante. También pueden ayudar a garantizar que los anuncios que ve en Internet sean más relevantes para usted y sus intereses.",
   :kyber.containers.privacy-policy/cookie-types "Tipos de cookies",
   :kyber.containers.privacy-policy/cookies "COOKIES",
   :kyber.containers.privacy-policy/edit-delete-access
   "CÓMO MODIFICAR, SUPRIMIR O ACCEDER A SUS DATOS PERSONALES",
   :kyber.containers.privacy-policy/feel-confident
   "Queremos que se sienta seguro al utilizar nuestro sitio y nuestras aplicaciones, y nos comprometemos a proteger la información personal que recopilamos. Limitamos el acceso a su información personal a los empleados que razonablemente necesitan acceder a ella para ofrecerle productos o servicios o para realizar su trabajo. Disponemos de las protecciones técnicas y organizativas físicas, electrónicas y de procedimiento adecuadas para proteger la información personal que nos proporciona contra el tratamiento no autorizado o ilícito y contra la pérdida, el daño o la destrucción accidentales.",
   :kyber.containers.privacy-policy/find-out
   "Puede obtener más información sobre ArcheMedX Inc. y las Condiciones de uso de nuestro sitio web en www.archemedx.com.",
   :kyber.containers.privacy-policy/first-party-cookies
   "Cookies de origen",
   :kyber.containers.privacy-policy/for-legal
   "Con fines legales, de protección y de seguridad;",
   :kyber.containers.privacy-policy/from-others
   "Información que recibimos de terceros",
   :kyber.containers.privacy-policy/gdpr
   "De conformidad con los requisitos de divulgación del Reglamento General de Protección de Datos (“RGPD”) de la Unión Europea, no utilizamos ningún dato que recopilemos de usted que afecte a sus derechos individuales.",
   :kyber.containers.privacy-policy/header "Política de Privacidad",
   :kyber.containers.privacy-policy/headquarters
   "ArcheMedX Inc. es una empresa con sede en 300 E Main St Suite 101, Charlottesville, VA 22902.",
   :kyber.containers.privacy-policy/how-to-delete
   "Cómo controlar o eliminar las cookies",
   :kyber.containers.privacy-policy/international-data
   "TRANSFERENCIA INTERNACIONAL DE DATOS PERSONALES",
   :kyber.containers.privacy-policy/ip-addr "Direcciones IP",
   :kyber.containers.privacy-policy/last-updated
   "Última actualización: 18 de marzo de 2020",
   :kyber.containers.privacy-policy/learner-data
   "Podemos compartir los datos individuales y agregados de los alumnos y las estadísticas de rendimiento con los usuarios autorizados de su organización.",
   :kyber.containers.privacy-policy/learner-performance
   "También recopilamos información sobre el rendimiento de los alumnos y sus pautas de aprendizaje. Hacemos un seguimiento de la información que indica, por ejemplo, qué secciones de nuestra aplicación se visitaron, el orden en que se visitaron, cuándo se las visitó, qué notas se tomaron, qué búsquedas se realizaron, qué recordatorios se establecieron, qué recursos se consultaron y qué hipervínculos y otros controles de la interfaz de usuario se utilizaron. Le recomendamos que consulte las declaraciones de privacidad de los sitios web a los que decida vincular desde el nuestro para que pueda comprender cómo recopilan, utilizan y comparten su información dichos sitios web. No somos responsables de las declaraciones de privacidad ni de otros contenidos de sitios web ajenos al nuestro.",
   :kyber.containers.privacy-policy/may-collect
   "Podemos recopilar información sobre su computadora o dispositivo móvil, incluida, cuando esté disponible, su dirección IP, sistema operativo, horas de inicio de sesión y tipo de navegador. Utilizamos esta información para comprender mejor cómo utilizan los visitantes nuestro sitio y para la elaboración de informes internos. No compartiremos esta información con ningún anunciante o empresa de marketing.",
   :kyber.containers.privacy-policy/more-info
   "Para obtener más información sobre las cookies, incluido cómo ver qué cookies se instalaron en su computadora o dispositivo móvil y cómo gestionarlas y eliminarlas, visite www.allaboutcookies.org y www.youronlinechoices.eu.",
   :kyber.containers.privacy-policy/name-and-stuff
   "Podemos recopilar su nombre, dirección postal, dirección de correo electrónico, número de teléfono, número de fax, nombre de usuario, contraseña e información demográfica (como su sexo y ocupación), así como otra información que nos facilite directamente en nuestro sitio o a través de nuestras aplicaciones. Además, también podemos recopilar información personal suya cuando intercambie correspondencia con nosotros (por ejemplo, cuando nos envíe comunicaciones por correo electrónico o cartas, o por teléfono). Ciertos datos personales que comparte con nosotros son obligatorios para que pueda utilizar nuestro servicio.",
   :kyber.containers.privacy-policy/no-rent
   "No alquilamos, vendemos ni compartimos información personal sobre usted con otras personas o empresas no afiliadas ajenas a ArcheMedX Inc., excepto en las siguientes circunstancias:",
   :kyber.containers.privacy-policy/obtain
   "Obtenemos información sobre usted de diversas maneras:",
   :kyber.containers.privacy-policy/other-sources
   "Es posible que obtengamos información sobre usted de otras fuentes. Es posible que agreguemos esto a la información que obtenemos de este sitio y de su uso de nuestras aplicaciones.",
   :kyber.containers.privacy-policy/outside-eea
   "Sus datos personales pueden recopilarse, procesarse o transferirse de otro modo fuera del Espacio Económico Europeo y pueden procesarse no solo en el país en el que fueron recopilados, sino también en otros países, incluidos los Estados Unidos, donde las leyes y normativas sobre protección y privacidad de datos pueden no ofrecer el mismo nivel de protección que en otras partes del mundo. Al facilitarnos sus datos personales, usted consiente dicha transferencia, recopilación o tratamiento en Estados Unidos de sus datos personales, lo que incluye el uso de cookies tal y como se describe en esta Política.",
   :kyber.containers.privacy-policy/over-13
   "Este sitio no está dirigido a ninguna persona que sepamos que es menor de 13 años, ni recopilamos información personal de ninguna persona que sepamos que es menor de 13 años. Si usted es menor de 13 años, no debe utilizar la plataforma ni enviarnos ninguna información personal.",
   :kyber.containers.privacy-policy/personal-purposes
   "Utilizamos sus datos personales para los siguientes fines:",
   :kyber.containers.privacy-policy/pixel-tags "Etiquetas de píxel",
   :kyber.containers.privacy-policy/protecting-your-info
   "PROTEGER SU INFORMACIÓN",
   :kyber.containers.privacy-policy/remain-on-device
   "Las cookies pueden permanecer en su computadora o dispositivo móvil durante distintos períodos. Algunas cookies son “cookies de sesión”, lo que significa que solo existen mientras su navegador está abierto. Se eliminan de forma automática una vez que cierra el navegador. Otras cookies son “cookies permanentes”, lo que significa que perduran después de cerrar el navegador. Pueden ser utilizadas por el sitio para reconocer la computadora o el dispositivo móvil al abrir el navegador y volver a navegar por Internet.",
   :kyber.containers.privacy-policy/retain-data
   "Conservaremos sus datos personales durante el período necesario para cumplir con los fines descritos en esta Política, a menos que la ley exija o permita un período de conservación más largo.",
   :kyber.containers.privacy-policy/retention-period
   "PERÍODO DE CONSERVACIÓN",
   :kyber.containers.privacy-policy/right-to-ask
   "Tiene derecho a solicitar una copia de cualquier información personal que tengamos sobre usted en nuestros registros, a corregir cualquier inexactitud y a actualizar cualquier información obsoleta. También puede pedirnos que no le enviemos comunicaciones de marketing directo (sin embargo, tenga en cuenta que podemos seguir enviándole comunicaciones relacionadas con el servicio (es decir, no de marketing), como actualizaciones por correo electrónico). Si desea ejercer alguno de estos derechos, o si desea oponerse a que utilicemos su información personal, escríbanos a la dirección indicada con anterioridad.",
   :kyber.containers.privacy-policy/right-to-choose
   "Usted tiene derecho a decidir si acepta o no las cookies y, a continuación, le explicamos cómo puede ejercer este derecho. Sin embargo, tenga en cuenta que, si no acepta nuestras cookies, puede experimentar algunos inconvenientes en el uso de nuestro sitio.",
   :kyber.containers.privacy-policy/served-directly
   ", provisto directamente por ArcheMedX a su computadora o dispositivo móvil. ArcheMedX solo las utiliza para reconocer su computadora o dispositivo móvil cuando vuelve a visitar nuestro sitio.",
   :kyber.containers.privacy-policy/share-aggregated
   "También podemos compartir datos agregados o anónimos con terceros para sus propios usos, como la investigación científica.",
   :kyber.containers.privacy-policy/sharing-data
   "DIVULGAR DATOS PERSONALES",
   :kyber.containers.privacy-policy/site-provider-served
   ", que brinda un proveedor de servicios en nuestro sitio, y puede utilizarlas el proveedor de servicios a fin de reconocer su computadora o dispositivo móvil cuando visita otros sitios. Las cookies de terceros se utilizan normalmente con fines de análisis o publicidad de la plataforma.",
   :kyber.containers.privacy-policy/take-a-moment
   "Tómese un momento para leer esta Política, en la que se detalla cómo recopilamos, utilizamos, divulgamos y transferimos la información personal que usted nos proporciona cuando visita nuestro sitio o utiliza nuestras aplicaciones.",
   :kyber.containers.privacy-policy/third-party-cookies
   "Cookies de terceros",
   :kyber.containers.privacy-policy/this-policy
   "En esta política de privacidad (“Política”) se describe el modo en que ArcheMedX, Inc. y sus empresas vinculadas recopilan, utilizan y comparten los datos personales de los usuarios de este sitio web, www.archemedx.com.",
   :kyber.containers.privacy-policy/time-to-time
   "Es posible que modifiquemos esta Política según se requiera. Si realizamos algún cambio, modificaremos la fecha de Última actualización indicada más arriba. Si no está de acuerdo con estos cambios, le rogamos que no siga utilizando nuestro sitio. Si se introducen modificaciones sustanciales en esta Política, se lo notificaremos por correo electrónico o mediante un aviso destacado en el sitio.",
   :kyber.containers.privacy-policy/to-archive
   "archivar dicha información o utilizarla para futuras comunicaciones con usted;",
   :kyber.containers.privacy-policy/to-communicate
   "comunicar actualizaciones de la oferta de cursos, próximos eventos y otras noticias sobre productos y servicios ofrecidos por nosotros y nuestros socios seleccionados;",
   :kyber.containers.privacy-policy/to-comply
   "cumplir con las leyes o cualquier obligación reglamentaria;",
   :kyber.containers.privacy-policy/to-enable
   "permitir a nuestros clientes personalizar su experiencia de aprendizaje e impartir, administrar y mejorar sus cursos respondiendo a las preguntas que plantee y revisar sus actividades de aprendizaje individuales para optimizar los resultados del aprendizaje;",
   :kyber.containers.privacy-policy/to-link
   "vincular o combinar la información del usuario con otros datos personales;",
   :kyber.containers.privacy-policy/to-operate
   "operar, mantener, supervisar y mejorar nuestros sitios, productos y servicios;",
   :kyber.containers.privacy-policy/to-protect-illegal
   "proteger, investigar y disuadir de actividades fraudulentas, no autorizadas o ilegales; y",
   :kyber.containers.privacy-policy/to-protect-rights
   "proteger los derechos y la propiedad de ArcheMedX Inc., nuestros agentes, clientes y otros. Esto incluye hacer cumplir nuestros acuerdos, políticas y Condiciones de uso.",
   :kyber.containers.privacy-policy/to-provide
   "proporcionar y entregar productos y servicios a petición de los clientes;",
   :kyber.containers.privacy-policy/to-respond-comments
   "responder a comentarios y preguntas y prestar servicios de atención al cliente;",
   :kyber.containers.privacy-policy/to-respond-lawful
   "responder a solicitudes legales y procesos judiciales;",
   :kyber.containers.privacy-policy/to-send
   "enviar información, como confirmaciones, facturas, avisos técnicos, actualizaciones, alertas de seguridad y mensajes administrativos y de asistencia;",
   :kyber.containers.privacy-policy/to-track
   "realizar un seguimiento de la participación individual, el progreso, el compromiso y la finalización de un curso en línea, y analizar estadísticas sobre el rendimiento de los alumnos y el modo en que aprenden los usuarios de nuestras aplicaciones.",
   :kyber.containers.privacy-policy/use-cookies
   "Nuestro sitio (como la mayoría de las plataformas) utiliza cookies y otras tecnologías similares, como las “balizas web”.",
   :kyber.containers.privacy-policy/use-of-personal
   "USO DE DATOS PERSONALES",
   :kyber.containers.privacy-policy/what-we-collect "LO QUE RECOPILAMOS",
   :kyber.containers.privacy-policy/wide-cookies
   "Las cookies se utilizan generalmente para que los sitios funcionen, o para que lo hagan de forma más eficiente, así como también para proporcionar información a los propietarios de la plataforma.",
   :kyber.containers.privacy-policy/with-consent
   "Con su consentimiento. Por ejemplo, puede permitirnos compartir datos personales con terceros para sus propios usos comerciales. Estos usos estarán sujetos a las políticas de privacidad de los terceros.",
   :kyber.containers.privacy-policy/wut-cookies "¿Qué son las cookies?",
   :kyber.containers.privacy-policy/you-give-us
   "Información que usted nos facilita",
   :kyber.containers.terms-and-conditions/access
   "EL ACCESO Y EL USO DEL SITIO WEB DE ARCHEMEDX (“EL SITIO”), O SUS CURSOS EDUCATIVOS EN LÍNEA, MÓVILES E INALÁMBRICOS BASADOS EN LA WEB, LAS HERRAMIENTAS DE SEGUIMIENTO Y ANÁLISIS DEL ALUMNO, JUNTO CON CUALQUIER VERSIÓN DE MARCA COMPARTIDA Y “DESARROLLADO POR” DE TERCEROS DE LOS MISMOS (COLECTIVAMENTE LA “APLICACIÓN”) ESTÁN SUJETOS A ESTOS TÉRMINOS Y CONDICIONES (“TÉRMINOS Y CONDICIONES”). LA APLICACIÓN ARCHEMEDX ESTÁ DISEÑADA PARA PROFESIONALES DE LA SALUD. PARA UTILIZAR LA APLICACIÓN, DEBE CREAR UNA CUENTA MEDIANTE EL PROCESO DE REGISTRO EN LÍNEA A TRAVÉS DEL SITIO O DE LOS PROVEEDORES DE FORMACIÓN MÉDICA (“ASOCIADOS COMERCIALES”). AL REGISTRARSE O UTILIZAR EL SITIO Y LA APLICACIÓN, USTED ACEPTA UN ACUERDO VINCULANTE ENTRE USTED Y ARCHEMEDX (“ACUERDO”). SI NO ESTÁ DE ACUERDO CON LOS TÉRMINOS Y CONDICIONES DE ESTE ACUERDO, NO PROCEDA AL REGISTRO O USO DE ESTA APLICACIÓN. ESTE ACUERDO INCLUYE, ENTRE OTRAS COSAS, LA POLÍTICA DE PRIVACIDAD DE ARCHEMEDX (“POLÍTICA DE PRIVACIDAD”), INCORPORADA AQUÍ POR ESTA REFERENCIA, ASÍ COMO TODOS Y CADA UNO DE LOS OTROS ACUERDOS A LOS QUE SE HACE REFERENCIA EN RELACIÓN CON SU REGISTRO O USO DE ESTA APLICACIÓN. USTED ACEPTA QUE ARCHEMEDX PUEDE MODIFICAR ESTE ACUERDO EN CUALQUIER MOMENTO MEDIANTE LA PUBLICACIÓN DE DICHOS TÉRMINOS Y CONDICIONES MODIFICADOS (“MODIFICACIONES”) EN ESTE SITIO WEB O APLICACIÓN. EL USO CONTINUADO DE ESTE SITIO WEB O DE LAS APLICACIONES DESPUÉS DE DICHA PUBLICACIÓN IMPLICA LA ACEPTACIÓN DE DICHAS MODIFICACIONES. A EFECTOS DE ESTOS TÉRMINOS Y CONDICIONES, ArcheMedX, el Sitio y la Aplicación pueden ser referidos colectivamente (aunque no exclusivamente) como “nosotros”, “nos” o “nuestro”. Las referencias a “usted”, “su” o “usuario” se refieren a los usuarios del sitio web, las plataformas móviles o inalámbricas y la Aplicación.",
   :kyber.containers.terms-and-conditions/additional-rights
   "Derechos adicionales Algunos estados o jurisdicciones no permiten la exclusión de garantías implícitas o la limitación de responsabilidad por daños incidentales, emergentes o de otro tipo, por lo que las exclusiones establecidas anteriormente en la sección 12 pueden no aplicarse en su caso.",
   :kyber.containers.terms-and-conditions/choice-of-law
   "Legislación aplicable Este Acuerdo, este Sitio y la Aplicación se rigen e interpretan de acuerdo con las leyes de la Mancomunidad de Virginia, sin dar efecto a ningún conflicto de disposiciones legales. Al utilizar el Sitio, la Aplicación y las Plataformas Inalámbricas, usted acepta por la presente la jurisdicción exclusiva de los tribunales estatales y federales situados en Charlottesville, Virginia, y la Mancomunidad de Virginia, y acepta que la jurisdicción es adecuada y conveniente en dichos tribunales. Cualquier pretensión que usted pueda tener con respecto a su uso del Sitio web. Las Plataformas Inalámbricas o Aplicaciones deben iniciarse en el plazo de un (1) año a partir del momento en que surja la reclamación o pretensión, renunciando así expresamente a cualquier plazo de prescripción aplicable.",
   :kyber.containers.terms-and-conditions/content-monitoring
   "Supervisión del Contenido: ArcheMedX, sus socios y Asociados Comerciales no tienen obligación alguna de supervisar, filtrar, editar o controlar de cualquier otro modo cualquier Contenido publicado o transmitido a través del Sitio o la Aplicación (colectivamente, “Publicaciones”). No obstante, ArcheMedX podrá, a su entera discreción, supervisar el Sitio y la Aplicación de ArcheMedX para determinar el cumplimiento de estos Términos y Condiciones y otros acuerdos, así como de todas las leyes y reglamentos aplicables. ArcheMedX podrá utilizar medios legales para interceptar o divulgar Publicaciones en la medida en que sea razonablemente necesario para proteger nuestros derechos o los derechos de terceros, o para cumplir con cualquier ley, reglamento o solicitud gubernamental. También podemos revisar, editar y negarnos a publicar o eliminar cualquier Publicación mostrada o transmitida a través del Sitio y la Aplicación de ArcheMedX.",
   :kyber.containers.terms-and-conditions/copyright
   "Agente designado para recibir notificaciones de infracciones de derechos de autor Puede solicitar la retirada de materiales del Sitio, la Aplicación o las Plataformas Inalámbricas si cree de buena fe que los materiales infringen sus derechos de autor. Póngase en contacto con ArcheMedX y facilite la siguiente información: (i) descripción y ubicación del material para ayudar a localizarlo; (ii) su nombre, dirección, correo electrónico y número de teléfono; (3) una declaración, firmada por el titular de los derechos de autor, de que el uso del material en el sitio web no está autorizado y de que cree que la información que facilitó es exacta.",
   :kyber.containers.terms-and-conditions/entire-agreement
   "Acuerdo completo Estos Términos y Condiciones y la Política de Privacidad de ArcheMedX constituyen el acuerdo completo entre ArcheMedX y usted con respecto al Sitio, las Plataformas Inalámbricas y la Aplicación y sustituye a todas las comunicaciones y propuestas anteriores y contemporáneas, ya sean electrónicas, orales o por escrito entre usted y ArcheMedX con respecto al Sitio y la Aplicación.",
   :kyber.containers.terms-and-conditions/header
   "Términos y Condiciones",
   :kyber.containers.terms-and-conditions/health-insurance-act
   "La Ley de Portabilidad y Responsabilidad del Seguro Médico de 1996 (Health Insurance Portability and Accountability Act of 1996) Usted garantiza específicamente que cualquier información revelada en comunicaciones a la Aplicación cumple con todos los requisitos aplicables de la Ley de Portabilidad y Responsabilidad del Seguro Médico de 1996 (Health Insurance Portability and Accountability Act of 1996, “HIPAA”) para la protección de la privacidad médica, así como con todas y cada una de los demás lineamientos federales y estatales vigentes, ahora o en el futuro. Es responsabilidad exclusiva de los Usuarios, facultativos, investigadores, profesionales de la salud y demás personas que utilicen el Sitio y la Aplicación garantizar el cumplimiento de las normas y requisitos de privacidad de la HIPAA en lo que respecta a la divulgación autorizada de información personal, identificativa o demográfica sobre determinados pacientes, participantes en investigaciones, clientes, entre otros, y dichas responsabilidades y obligaciones serán indelegables e intransferibles.",
   :kyber.containers.terms-and-conditions/indemnification
   "Indemnidad Usted se compromete a mantener indemne y eximir de toda responsabilidad a ArcheMedX, sus directivos, agentes, empleados, otorgantes de licencias, Socios Comerciales y proveedores frente a cualquier reclamación, acción, demanda, responsabilidad o pérdida, incluidos los honorarios razonables de abogados y contables, que se deriven o se aleguen como resultado de la infracción por su parte de los Términos y Condiciones de este Acuerdo, o de su uso o confianza en el Sitio, la Aplicación, la Plataforma Inalámbrica o cualquier contenido o información disponible en ellos.",
   :kyber.containers.terms-and-conditions/internet-delays
   "Retrasos en Internet EL SITIO Y LA APLICACIÓN DE ARCHEMEDX PUEDEN ESTAR SUJETOS A LIMITACIONES, RETRASOS Y OTROS PROBLEMAS INHERENTES AL USO DE INTERNET. ARCHEMEDX NO SE HACE RESPONSABLE DE LOS RETRASOS, FALLAS DE ENTREGA U OTROS DAÑOS DERIVADOS DE DICHOS PROBLEMAS.",
   :kyber.containers.terms-and-conditions/liability
   "Limitación de responsabilidad ArcheMedX, sus funcionarios, directores, filiales, agentes, Otorgantes de Licencias, Socios Comerciales y proveedores no son responsables de ninguna reclamación o pérdida de ningún tipo, ya sean daños directos, incidentales, indirectos, emergentes, especiales, punitivos o ejemplares de ningún tipo, ya sea que surjan de una acción contractual, extracontractual o de otro tipo, relacionada con el Sitio, la Aplicación, cualquier Plataforma Inalámbrica o cualquier otra aplicación o información disponible en este Sitio o Aplicación o a través de ellos o su uso de ellos. Asimismo, ArcheMedX y sus filiales no serán responsables de ninguna reclamación o pérdida, incluida la pérdida de ingresos o lucro cesante, la pérdida de datos o negocios, en relación con el uso o la imposibilidad de uso del Sitio, la Aplicación o las Plataformas Inalámbricas, o por cualquier reclamación o lesión basada en errores, omisiones, interrupciones u otras imprecisiones del Sitio, la Aplicación, las Plataformas Inalámbricas o el contenido en ellos, o cualquier decisión tomada o acción emprendida en función del contenido del Sitio, la Aplicación o las Plataformas Inalámbricas o accesible a través de ellos, incluidos, entre otros, los daños personales o la muerte, aunque ArcheMedX haya sido advertida de la posibilidad de tales daños. Su único recurso para cualquier reclamación relacionada con este Sitio, las Plataformas Inalámbricas o la Aplicación es dejar de utilizar el Sitio, la Aplicación, las Plataformas Inalámbricas y cualquier información o aplicación relacionadas. La limitación anterior se aplicará y subsistirá a pesar de cualquier falla de la finalidad esencial de cualquier recurso.",
   :kyber.containers.terms-and-conditions/license
   "Concesión de licencia, restricciones y titularidad de la propiedad intelectual: ArcheMedX le concede un derecho no exclusivo e intransferible a utilizar el Sitio y la Aplicación únicamente para su uso personal, no comercial y no competitivo, sujeto en todo momento a los Términos y Condiciones del presente Acuerdo. Todas las formas de material educativo, literario y científico, contenido de audio y video, texto, fotografías, diseños, marcas y logotipos (el “Contenido”), software y herramientas de autoría, seguimiento y análisis basadas en la Web (la “Tecnología”) que se proporcionan a través de la Aplicación o el Sitio son propiedad de ArcheMedX, sus terceros editores de contenido (“Otorgantes de Licencias”) y Socios Comerciales, o están bajo su licencia o control.",
   :kyber.containers.terms-and-conditions/logo-alt
   "Logotipo de ArcheMedX",
   :kyber.containers.terms-and-conditions/no-medical-advice
   "Sin consejo médico Usted acepta que el Sitio y la Aplicación, junto con cualquier contenido proporcionado por medio de ellos, están destinados a utilizarse únicamente como educación médica, no como consejo médico. Esta Aplicación está destinada a los profesionales de la salud. Los profesionales de la salud que utilicen la Aplicación asumen toda la responsabilidad por el uso médicamente apropiado de toda la información recopilada a través de la Aplicación. Usted acepta, como profesional de la salud, ejercer su juicio profesional independiente con respecto a la información proporcionada a través de la Aplicación y confirmar toda la información proporcionada a través de la Aplicación con las normas médicas profesionales aplicables en su jurisdicción de licencia y las de cualquier organismo profesional al que pertenezca antes de basar cualquier tratamiento en ella.",
   :kyber.containers.terms-and-conditions/notices
   "Avisos ArcheMedX podrá dar avisos mediante un aviso general en la Aplicación, el Sitio, las Plataformas Inalámbricas o por correo electrónico a su dirección de correo electrónico registrada en la información de su cuenta, o mediante comunicación escrita enviada por correo postal principal de primera clase o correo prepagado a la dirección registrada en la información de su cuenta. Dicho aviso se considerará efectuado una vez transcurridas 48 horas desde su envío por correo o franqueo (si se envía por correo postal de primera clase o correo prepagado) o 12 horas desde su envío (si se envía por correo electrónico). Usted dar aviso a ArcheMedX (dicho aviso se considerará entregado cuando sea recibido por ArcheMedX) en cualquier momento mediante carta enviada por correo certificado a: ArcheMedX, Inc, 300 E Main St Suite 101, Charlottesville, VA 22902.",
   :kyber.containers.terms-and-conditions/privacy
   "Política de Privacidad: la Política de Privacidad de ArcheMedX puede consultarse en www.archemedx.com. ArcheMedX se reserva el derecho a modificar su Política de Privacidad en cualquier momento. Al registrarse, los usuarios tendrán la oportunidad de optar por no recibir alertas y otras comunicaciones no críticas de ArcheMedX relacionadas con la Aplicación. No obstante, como aplicación alojada en línea, móvil o inalámbrica, ArcheMedX podrá notificar ocasionalmente a los usuarios (independientemente de su estado de exclusión voluntaria) sobre el funcionamiento de la Aplicación y las cuentas de usuario.",
   :kyber.containers.terms-and-conditions/representations
   "Declaraciones  Como usuario de la Aplicación, Usted es responsable de la exactitud de la información que proporcione a ArcheMedX, sus socios y Socios Comerciales, incluidas, entre otras cosas, sus declaraciones personales y profesionales según lo dispuesto en la sección sobre el uso. Mediante este documento, certifica que no tiene ningún interés financiero ni es un consultor remunerado que actúe en nombre de ninguna entidad, producto o servicio que pudiera beneficiarse de la información que proporcione a este Sitio, incluido, entre otros, la promoción de usos de fármacos “no indicados en la etiqueta”, la divulgación de ensayos clínicos confidenciales u otra información de propiedad.",
   :kyber.containers.terms-and-conditions/responsibilities
   "Responsabilidades del usuario. (a) Contraseña y seguridad: usted es el único responsable de toda la actividad que ocurra bajo su contraseña o cuenta utilizadas para acceder a la Aplicación. Usted es el único responsable de mantener la confidencialidad de su contraseña y de su cuenta, de asegurarse de que sale de su cuenta al final de cada sesión y de cualquier pérdida, daño, consecuencia u otras eventualidades derivadas de cualquier falla en este sentido. Usted es responsable de notificar inmediatamente a ArcheMedX en caso de uso no autorizado de cualquier contraseña o cuenta o de cualquier otra infracción de seguridad conocida o sospechada. Ni ArcheMedX, ni ninguno de sus Otorgantes de Licencias o Socios Comerciales son responsables de ninguna pérdida o daño que surja de su incumplimiento de sus responsabilidades; (b) Información y datos de la cuenta: usted es el único responsable de todos los aspectos de la información que envíe (“Datos del Cliente”) en el curso del registro y uso de la Aplicación. ArcheMedX no se hace responsable de la pérdida, destrucción, eliminación o imposibilidad de almacenar los Datos del Cliente.",
   :kyber.containers.terms-and-conditions/rights
   "ArcheMedX y sus Otorgantes de Licencias se reservan todos los derechos no concedidos expresamente al usuario. Usted no podrá (i) conceder licencias, sublicenciar, publicar, vender, revender, transferir, ceder, distribuir o explotar comercialmente de cualquier otra forma o poner a disposición de terceros el sitio web, la Aplicación, la Tecnología o el Contenido de ninguna manera; (ii) modificar, editar o copiar la Aplicación, el Contenido o la Tecnología; (iii) ni realizar trabajos derivados de la Aplicación, el Contenido o la Tecnología. Esta licencia de acceso al Sitio o a la Aplicación no podrá ser compartida ni utilizada por más de una persona. ArcheMedX (junto con sus Otorgantes de Licencias y Socios Comerciales, en su caso) posee todos los derechos, títulos e intereses sobre toda la propiedad intelectual relacionada con el Sitio, la Aplicación, la Tecnología y el Contenido. Este Acuerdo no le confiere ningún derecho de propiedad sobre la Aplicación, el Contenido, el Sitio o la Tecnología. ArcheMedX se reserva el derecho, a su entera discreción, de cambiar, modificar, agregar o eliminar cualquier parte del Sitio o de las Aplicaciones, en su totalidad o en parte, en cualquier momento, en cuyo caso usted acepta que estos Términos y Condiciones y este Acuerdo permanezcan en vigor.",
   :kyber.containers.terms-and-conditions/survival
   "Supervivencia Las siguientes disposiciones permanecerán vigente independientemente de cualquier rescisión o extinción del presente Acuerdo: la presente sección 19, las secciones 4, 7, 11, 12, 13, 14, 17, 18, 19, 20, 21 y 22.",
   :kyber.containers.terms-and-conditions/termination
   "Rescisión Cualquier incumplimiento o uso no autorizado de la Aplicación, el Sitio o la tecnología relacionada de ArcheMedX se considerará un incumplimiento sustancial de este Acuerdo. ArcheMedX podrá, a su entera discreción, con o sin previo aviso, rescindir o suspender inmediatamente su contraseña, cuenta o uso de la Aplicación si incumple con este Acuerdo o no cumple de la forma correspondiente con él. En caso de rescisión por incumplimiento sustancial, ArcheMedX no tendrá obligación alguna de conservar los Datos del Cliente y podrá eliminarlos sin previo aviso. ArcheMedX también podrá, a su entera discreción y en cualquier momento, dejar de proporcionar el Sitio, la Aplicación o cualquier parte de los mismos, por cualquier motivo, con o sin previo aviso. Usted acepta que ArcheMedX no será responsable ante usted por la cancelación de su acceso al Sitio o a la Aplicación.",
   :kyber.containers.terms-and-conditions/third-party-accreditation
   "Acreditación de terceros Usted acepta que ArcheMedX no se responsabiliza de ningún aspecto de los créditos de formación médica continuada que puedan emitirse como resultado de su uso de la Aplicación.",
   :kyber.containers.terms-and-conditions/third-party-interactions
   "Interacciones con terceros, afiliaciones, relaciones de marca compartida ArcheMedX trabaja habitualmente con terceros para proporcionar la Aplicación a través de diversos sitios web, plataformas móviles e inalámbricas “Plataformas Inalámbricas” y para proporcionar vínculos a otros sitios web (“Sitios de Terceros” y “Plataformas Inalámbricas”). Estos Sitios de Terceros y Plataformas Inalámbricas pueden incluir organismos de acreditación, editores de contenidos, proveedores de tecnología y Socios Comerciales que pueden, junto con ArcheMedX, proporcionar una versión de la Aplicación de marca compartida o “Desarrollada por”. Estas entidades pueden suministrar información o contenidos al Sitio y a la Aplicación. ArcheMedX puede proporcionar vínculos a Sitios de Terceros y Plataformas Inalámbricas. Estos vínculos se facilitan por comodidad y ArcheMedX no respalda ni tiene control alguno sobre los Sitios de Terceros o Plataformas. En ningún caso ArcheMedX será responsable de los daños o pérdidas resultantes del uso o la confianza depositada en los materiales, contenidos o Aplicaciones proporcionados a través de dichos Sitios de Terceros o Plataformas. Usted reconoce y entiende que determinados Sitios de Terceros o Plataformas Inalámbricas pueden requerir su aceptación de términos y condiciones y políticas de privacidad adicionales o diferentes antes de que usted utilice o acceda a determinadas Aplicaciones, software o sitios web, y que ArcheMedX no asume ninguna responsabilidad al respecto. En el caso de la versión de marca compartida o “Desarrollada por” de la Aplicación, los términos y condiciones y la política de privacidad del Socio Comercial pueden regir su uso de la versión de marca compartida o “Desarrollada por” de la Aplicación.",
   :kyber.containers.terms-and-conditions/waiver
   "Divisibilidad/renuncia En caso de que un tribunal competente declare inaplicable o inválida alguna de las disposiciones de estos Términos y Condiciones, el resto de estos continuará en pleno vigor y efecto. El hecho de que ArcheMedX no ejerza o haga valer cualquier derecho o disposición de estos Términos y Condiciones no constituirá ni se considerará una renuncia a dicho derecho o disposición.",
   :kyber.containers.terms-and-conditions/warranty
   "Renuncia de garantía ESTE SITIO, LA APLICACIÓN Y TODO SU CONTENIDO Y TECNOLOGÍA SE PROPORCIONAN ESTRICTAMENTE TAL CUAL SE PRESENTAN. UTILICE ESTA APLICACIÓN BAJO SU PROPIA RESPONSABILIDAD. USTED ACEPTA QUE NO EXISTE NINGUNA GARANTÍA DE COMERCIABILIDAD; NINGUNA GARANTÍA EXPRESA O IMPLÍCITA; NINGUNA GARANTÍA DE IDONEIDAD PARA NINGÚN FIN Y NINGUNA GARANTÍA EN RELACIÓN CON LA TECNOLOGÍA O EL CONTENIDO DEL SITIO, DE LA APLICACIÓN O DE LAS PLATAFORMAS INALÁMBRICAS. USTED DEBE EVALUAR LA INFORMACIÓN CONTENIDA EN ESTE SITIO Y EN LA APLICACIÓN Y TOMAR SUS PROPIAS DECISIONES BASÁNDOSE EN SU CRITERIO PROFESIONAL. USTED ACEPTA Y RECONOCE QUE EL CONTENIDO Y LA INFORMACIÓN PROPORCIONADOS A TRAVÉS DE ESTE SITIO Y LA APLICACIÓN SON PROPORCIONADOS POR TERCEROS Y QUE ARCHEMEDX NO ES RESPONSABLE DE DICHO CONTENIDO E INFORMACIÓN. ASIMISMO, USTED RECONOCE Y ACEPTA QUE ARCHEMEDX NO DECLARA NI GARANTIZA QUE (A) EL USO DE LA APLICACIÓN SEA SEGURO, PUNTUAL, ININTERRUMPIDO O LIBRE DE ERRORES; (B) LA APLICACIÓN CUMPLIRÁ CON SUS REQUISITOS O EXPECTATIVAS; O (C) SE CORRIJAN LOS ERRORES.",
   :kyber.events.authentication/check-inbox
   "Verifique su bandeja de entrada. Enviamos un correo electrónico de confirmación a la dirección ingresada. Siga los pasos indicados en el correo electrónico para proceder.",
   :kyber.events.authentication/could-not-save-changes
   "No se pudo guardar los cambios",
   :kyber.events.authentication/current-password-incorrect
   "La contraseña actual es incorrecta.",
   :kyber.events.authentication/email-not-verified
   "El correo electrónico no está verificado",
   :kyber.events.authentication/password-not-saved
   "No se pudo guardar la contraseña",
   :kyber.events.authentication/password-updated
   "Se actualizó la contraseña",
   :kyber.events.authentication/resent-message
   "Se reenvió su correo electrónico",
   :kyber.events.authentication/reset-sent
   "Se envió un correo electrónico para restablecer la contraseña.",
   :kyber.events.authentication/send-another
   "¿Desea que le enviemos otro correo electrónico de verificación?",
   :kyber.events.authentication/send-another-verification
   "¿Desea que le enviemos otro correo electrónico de verificación?",
   :kyber.events.authentication/thanks-for-signing-up
   "Gracias por inscribirse.",
   :kyber.events.authentication/too-many-change-attempts
   "Demasiados intentos de cambio de contraseña. Inténtelo de nuevo más tarde.",
   :kyber.events.authentication/verification-sent
   "Se envió un correo electrónico de verificación.",
   :kyber.router/data-message "Espere mientras recuperamos sus datos",
   :kyber.utils/i18n-date->date-time-string
   (inst-fmt
    "{month-numeric-padded}/{day-padded}/{year} {hour12}:{minutes-padded} {dayperiod}"),
   :kyber.utils/model->cms-time-format
   (inst-fmt "{month-short} {day}, {year}"),
   :kyber.utils/model->cms-time-format-last-updated
   "Última actualización: {1}",
   :kyber.utils/model->cms-time-format-no-date-time
   "Sin información de fecha y hora",
   :kyber.utils/moment-title-highlight "Su anotación",
   :kyber.utils/moment-title-note "Nota del educador",
   :kyber.utils/moment-title-question "Pregunta",
   :kyber.utils/moment-title-text "Su anotación",
   :kyber.utils/moment-title-timeline-user-note "Su nota",
   :learner.components.composite.active-moment/add-note "Agregar nota",
   :learner.components.composite.active-moment/continue "Continuar",
   :learner.components.composite.active-moment/edit-note "Editar nota",
   :learner.components.composite.active-moment/page-number "Página {1}",
   :learner.components.composite.active-moment/skip "Omitir por ahora",
   :learner.components.composite.active-moment/what-to-remember
   "¿Qué le gustaría recordar de este momento?",
   :learner.components.composite.active-moment-question-results/answer
   "Su respuesta",
   :learner.components.composite.active-moment-question-results/chosen-correct-answer
   "Su respuesta es correcta.",
   :learner.components.composite.active-moment-question-results/feedback
   "Comentarios del educador",
   :learner.components.composite.active-moment-question-results/guessing
   "Estoy adivinando",
   :learner.components.composite.active-moment-question-results/other-correct-answer
   "Respuesta correcta",
   :learner.components.composite.active-moment-question-results/peers-answered
   "Cómo respondieron sus compañeros:",
   :learner.components.composite.active-moment-question-results/all-collected-responses
   "Todas las respuestas recogidas:",
   :learner.components.composite.active-moment-question-results/sure
   "Estoy seguro",
   :learner.components.composite.active-moment-question-results/think
   "Pienso",
   :learner.components.composite.active-whisper/view-resource
   "Ver recurso",
   :learner.components.composite.active-whisper/view-resources
   "Ver recursos",
   :learner.components.composite.activity-control-bar.core/adjust-playback
   "Ajustar la velocidad de reproducción",
   :learner.components.composite.activity-control-bar.core/learning-stream
   "Flujo de aprendizaje",
   :learner.components.composite.activity-control-bar.core/open-learning-stream
   "Abra su flujo de aprendizaje",
   :learner.components.composite.activity-control-bar.core/rewind-15
   "Retroceder 15 segundos",
   :learner.components.composite.activity-control-bar.moment-preview/educator-note
   "Nota del educador",
   :learner.components.composite.activity-control-bar.moment-preview/learning-moment
   "Momento de aprendizaje",
   :learner.components.composite.activity-control-bar.moment-preview/note
   "Nota",
   :learner.components.composite.activity-control-bar.moment-preview/question
   "Pregunta",
   :learner.components.composite.activity-control-icons/continue-reading
   "CONTINUAR LEYENDO",
   :learner.components.composite.activity-control-icons/editing-moment
   "Está editando un momento, guarde los cambios para continuar con la actividad.",
   :learner.components.composite.activity-control-icons/editing-resource
   "Está editando un recurso, guarde los cambios para continuar con el video.",
   :learner.components.composite.activity-control-icons/pending-changes
   "Cambios pendientes",
   :learner.components.composite.activity-control-icons/restart-video
   "REINICIAR VIDEO",
   :learner.components.composite.activity-control-icons/resume-video
   "REANUDAR VIDEO",
   :learner.components.composite.activity-digest.activity-notes/activity-notes
   "Las notas de su actividad",
   :learner.components.composite.activity-digest.activity-notes/comment
   "Comentario",
   :learner.components.composite.activity-digest.activity-notes/educator-note
   "Nota del educador",
   :learner.components.composite.activity-digest.activity-notes/educator-question
   "Pregunta del educador",
   :learner.components.composite.activity-digest.activity-notes/feedback
   "Comentarios del educador",
   :learner.components.composite.activity-digest.activity-notes/no-notes
   "No escribió ninguna nota.",
   :learner.components.composite.activity-digest.activity-notes/page
   "Página {1}",
   :learner.components.composite.activity-digest.activity-notes/resource
   "Recurso",
   :learner.components.composite.activity-digest.activity-notes/taken-at
   "Tomado a las {1}",
   :learner.components.composite.activity-digest.activity-notes/video-still
   "Fotograma de video",
   :learner.components.composite.activity-digest.activity-notes/your-note
   "Su nota",
   :learner.components.composite.activity-digest.footer/archemedx
   "Desarrollado por ArcheMedX",
   :learner.components.composite.activity-digest.objective-card/no-sections
   "Sin secciones {1}",
   :learner.components.composite.activity-digest.objective-card/skipped
   "omitido",
   :learner.components.composite.activity-digest.objective-card/summary
   "Sus secciones {verb} de la cubierta {resource-type}",
   :learner.components.composite.activity-digest.objective-card/viewed
   "visto",
   :learner.components.composite.activity-digest.resource-card/no-description
   "No se proporcionó una descripción.",
   :learner.components.composite.activity-pdf/activity-review
   "Próximos pasos, visite la revisión de la actividad",
   :learner.components.composite.activity-pdf/curriculum
   "Próximos pasos, visite el plan de estudios",
   :learner.components.composite.activity-splash/begin-activity
   "Comenzar actividad",
   :learner.components.composite.activity-splash/moment-review-prompt
   "Después de revisar este momento de aprendizaje, se le pedirá que vuelva al modo revisión.",
   :learner.components.composite.activity-splash/moment-review-visit
   "Cuando haya terminado de revisar este momento, vuelva al modo de revisión abriendo su flujo de aprendizaje y seleccionando Visitar revisión de la actividad.",
   :learner.components.composite.activity-splash/of "de",
   :learner.components.composite.activity-splash/page "Página",
   :learner.components.composite.activity-splash/page-progress
   "Página {start-page} de {end-page}",
   :learner.components.composite.activity-splash/page-segment
   "Página: {1}",
   :learner.components.composite.activity-splash/play "Reproducir",
   :learner.components.composite.activity-splash/resume-where-you-left-off
   "Reanudar donde lo dejó",
   :learner.components.composite.activity-splash/review-learning-moment
   "Revisar el momento de aprendizaje",
   :learner.components.composite.activity-splash/start-at-the-beginning
   "Comenzar desde el principio",
   :learner.components.composite.activity-splash/start-video
   "COMENZAR VIDEO",
   :learner.components.composite.activity-splash/view-document
   "Ver documento",
   :learner.components.composite.activity-splash/view-your-note
   "Ver su nota",
   :learner.components.composite.activity-splash/what-would-you-like-to-do
   "¿Qué le gustaría hacer?",
   :learner.components.composite.admin-link/view-in-admin
   "Ver como administrador",
   :learner.components.composite.bookmark-feed/no-content
   "No tiene ningún contenido anclado.",
   :learner.components.composite.bookmark-feed/note-screenshot
   "Captura de pantalla de la nota",
   :learner.components.composite.bookmark-feed/open "Abrir",
   :learner.components.composite.bookmark-feed/play "Reproducir",
   :learner.components.composite.bookmark-feed/view-in-doc
   "Ver en documento",
   :learner.components.composite.branded-navbar/account "Cuenta",
   :learner.components.composite.branded-navbar/help "Ayuda",
   :learner.components.composite.branded-navbar/home "Inicio",
   :learner.components.composite.cme-front-matter/view-info
   "Ver información sobre el CME",
   :learner.components.composite.curriculum-banner/curriculum
   "PLAN DE ESTUDIOS",
   :learner.components.composite.download-digest-button/download-digest
   "Descargar el resumen",
   :learner.components.composite.emphasized-banner/pay-attention
   "Preste atención a esto {1}",
   :learner.components.composite.highlighted-moment-preview/view-video
   "Ver video",
   :learner.components.composite.leaderboard/activity-completion
   "Completó {completed} de {total-activities}",
   :learner.components.composite.leaderboard/avg-completion
   "Completó {average-learner-completion} de {total-activities}",
   :learner.components.composite.leaderboard/avg-progress
   "Progreso medio del plan de estudios",
   :learner.components.composite.leaderboard/leaderboard "Clasificación",
   :learner.components.composite.leaderboard/no-activity-completion
   "Completó 0 de {total-activities}",
   :learner.components.composite.leaderboard/no-other-learners
   "Ningún otro estudiante participó aún en este plan de estudios.",
   :learner.components.composite.leaderboard/other-learners
   "Otros estudiantes",
   :learner.components.composite.leaderboard/performance
   "Su rendimiento",
   :learner.components.composite.learning-stream-sidebar/end-of-document
   "FIN DEL DOCUMENTO",
   :learner.components.composite.learning-stream-sidebar/end-of-video
   "FIN DEL VIDEO",
   :learner.components.composite.learning-stream-sidebar/help "Ayuda",
   :learner.components.composite.learning-stream-sidebar/learning-stream
   "FLUJO DE APRENDIZAJE",
   :learner.components.composite.learning-stream-sidebar/learning-stream-description
   "Dentro de su flujo de aprendizaje, puede acceder a los momentos de aprendizaje y notas del educador visualizados, así como a sus notas personales y a cualquier elemento que haya anclado para más tarde.",
   :learner.components.composite.learning-stream-sidebar/learning-stream-importance
   "Su flujo de aprendizaje es importante. Considérelo su ayudante personal.",
   :learner.components.composite.learning-stream-sidebar/notes "NOTAS",
   :learner.components.composite.learning-stream-sidebar/pinned-content
   "CONTENIDO ANCLADO",
   :learner.components.composite.learning-stream-sidebar/resume-video
   "REANUDAR VIDEO",
   :learner.components.composite.learning-stream-sidebar/start-of-document
   "COMIENZO DEL DOCUMENTO",
   :learner.components.composite.learning-stream-sidebar/start-of-video
   "COMIENZO DEL VIDEO",
   :learner.components.composite.learning-stream-sidebar/visit-activity-review
   "Visitar revisión de la actividad",
   :learner.components.composite.learning-stream-sidebar/visit-curriculum
   "Visitar plan de estudios",
   :learner.components.composite.learning-stream-sidebar/welcome-learning-stream
   "Bienvenido a su flujo de aprendizaje",
   :learner.components.composite.learning-stream.editing-states/moment-image
   "Imagen del momento",
   :learner.components.composite.learning-stream.editing-states/question
   "Pregunta",
   :learner.components.composite.learning-stream.editing-states/video-still
   "Fotograma de video",
   :learner.components.composite.learning-stream.editing-states/what-to-remember
   "¿Qué le gustaría recordar de este momento?",
   :learner.components.composite.learning-stream.expanded-states/empty-note-list
   "No hay nota que mostrar. Si agrega uno, aparecerá aquí.",
   :learner.components.composite.learning-stream.expanded-states/moment-img
   "Imagen del momento",
   :learner.components.composite.learning-stream.expanded-states/video-still
   "Fotograma de video",
   :learner.components.composite.learning-stream.expanded-states/what-to-remember
   "¿Qué le gustaría recordar de este momento?",
   :learner.components.composite.learning-stream.preview-states/empty-notes
   "No hay nota que mostrar. Si agrega uno, aparecerá aquí.",
   :learner.components.composite.learning-stream.preview-states/resource-preview
   "Vista previa del recurso",
   :learner.components.composite.learning-stream.shared/add-note
   "Agregar nota",
   :learner.components.composite.learning-stream.shared/answer-later
   "Responder más tarde",
   :learner.components.composite.learning-stream.shared/answer-question
   "Responder pregunta",
   :learner.components.composite.learning-stream.shared/continue
   "Continuar",
   :learner.components.composite.learning-stream.shared/edit-note
   "Editar nota",
   :learner.components.composite.learning-stream.shared/moment-type-and-author
   (icu/msg
    "{author, select, educator {Educador } other {Su }} {momentType}"),
   :learner.components.composite.learning-stream.shared/page-number
   "Página {1}",
   :learner.components.composite.learning-stream.shared/page-number-colon
   "Página: {1}",
   :learner.components.composite.learning-stream.shared/play-btn-copy
   "Reproducir",
   :learner.components.composite.learning-stream.shared/play-in-video
   "Reproducir en video",
   :learner.components.composite.learning-stream.shared/question-moment
   (icu/msg
    "{momentType, select, question {Pregunta} other {{momentTitle}}}"),
   :learner.components.composite.learning-stream.shared/review-later
   "Revisar más tarde",
   :learner.components.composite.learning-stream.shared/view-btn-copy
   "Ver en documento",
   :learner.components.composite.learning-stream.shared/view-in-pdf
   "Ver en PDF",
   :learner.components.composite.navbar/logo
   "Logotipo de {partner-name}",
   :learner.components.composite.notepad/add-note "Agregar una nota",
   :learner.components.composite.notepad/add-video-still
   "Agregar fotograma del video",
   :learner.components.composite.notepad/remember-moment
   "¿Qué le gustaría recordar de este momento?",
   :learner.components.composite.notepad/remove-video-still
   "Quitar fotograma del video",
   :learner.components.composite.notepad/screenshot-alt "Captura",
   :learner.components.composite.notes-feed/no-notes "No tiene notas.",
   :learner.components.composite.notes-feed/recently-updated-notes
   "Las notas actualizadas recientemente aparecen en primer lugar",
   :learner.components.composite.questionnaire.active-question/optional-or-required
   (icu/msg
    "({isRequired, select, true {obligatorio} other {Opcional}})"),
   :learner.components.composite.questionnaire.active-question/question-number
   "Pregunta {1}",
   :learner.components.composite.questionnaire.questionnaire-submit/answer-to-submit
   "Para enviarlo, vuelva atrás y responda a todas las preguntas obligatorias.",
   :learner.components.composite.questionnaire.questionnaire-submit/evaluation
   "Evaluación",
   :learner.components.composite.questionnaire.questionnaire-submit/missed-something
   "Parece que le faltó algo.",
   :learner.components.composite.questionnaire.questionnaire-submit/post-test
   "Prueba posterior",
   :learner.components.composite.questionnaire.questionnaire-submit/pre-test
   "Prueba previa",
   :learner.components.composite.questionnaire.questionnaire-submit/question-number
   "Pregunta {1}",
   :learner.components.composite.questionnaire.questionnaire-submit/questionnaire
   "Cuestionario",
   :learner.components.composite.questionnaire.questionnaire-submit/ready-to-submit
   "¿Listo para enviar?",
   :learner.components.composite.questionnaire.questionnaire-submit/required
   "(Obligatorio)",
   :learner.components.composite.questionnaire.questionnaire-submit/submit
   "Enviar",
   :learner.components.composite.questionnaire.questionnaire-submit/submit-or-answer
   "Envíe o responda cualquiera de las preguntas opcionales omitidas que se muestran a continuación.",
   :learner.components.composite.questionnaire.questionnaire-submit/submit-or-review
   "Envíelo o, si desea revisar sus respuestas, puede volver a cualquier pregunta utilizando las pestañas de arriba.",
   :learner.components.composite.questionnaire.results/additional-resources
   "Recursos adicionales",
   :learner.components.composite.questionnaire.results/back-to-review
   "Volver a revisión de la actividad",
   :learner.components.composite.questionnaire.results/continue-to-activity
   "Continuar a actividad",
   :learner.components.composite.questionnaire.results/correct
   "Correcto",
   :learner.components.composite.questionnaire.results/correct-answer
   "Respuesta correcta",
   :learner.components.composite.questionnaire.results/educator-feedback
   "Comentarios del educador",
   :learner.components.composite.questionnaire.results/get-credit
   "Obtener crédito",
   :learner.components.composite.questionnaire.results/go-home
   "Ir a inicio",
   :learner.components.composite.questionnaire.results/graded-summary
   "Respondió {1} de {2} preguntas calificadas correctamente.",
   :learner.components.composite.questionnaire.results/guess
   "Estoy adivinando",
   :learner.components.composite.questionnaire.results/incorrect
   "Incorrecto",
   :learner.components.composite.questionnaire.results/na "N/A",
   :learner.components.composite.questionnaire.results/no-answer
   "No se respondió",
   :learner.components.composite.questionnaire.results/or "o",
   :learner.components.composite.questionnaire.results/participation-thanks
   "Gracias por participar en el cuestionario.",
   :learner.components.composite.questionnaire.results/post-test
   "Prueba posterior",
   :learner.components.composite.questionnaire.results/pre-test
   "Prueba previa",
   :learner.components.composite.questionnaire.results/question-number
   "Pregunta {1}",
   :learner.components.composite.questionnaire.results/questionnaire
   "Cuestionario",
   :learner.components.composite.questionnaire.results/restart-post-test
   "Reiniciar la prueba posterior",
   :learner.components.composite.questionnaire.results/attempts-exhausted
   "No Hay Más Intentos Disponibles",
   :learner.components.composite.questionnaire.results/restart-questionnaire
   "Reiniciar cuestionario",
   :learner.components.composite.questionnaire.results/results
   "Resultados",
   :learner.components.composite.questionnaire.results/review-or-post-test
   "Le recomendamos que vuelva a la revisión de la actividad, o puede reiniciar ahora la prueba posterior.",
   :learner.components.composite.questionnaire.results/review-or-questionnaire
   "Le recomendamos que vuelva a la revisión de la actividad, o puede reiniciar el cuestionario ahora.",
   :learner.components.composite.questionnaire.results/review-only-attempts-exhausted
   "Le recomendamos que vuelva a la revisión de la actividad.",
   :learner.components.composite.questionnaire.results/submit-thanks
   "Gracias por enviar la evaluación.",
   :learner.components.composite.questionnaire.results/sure
   "Estoy seguro",
   :learner.components.composite.questionnaire.results/take-evaluation
   "Hacer evaluación",
   :learner.components.composite.questionnaire.results/tested-out
   "No es necesario que realice esta actividad, según su rendimiento en la prueba previa.",
   :learner.components.composite.questionnaire.results/unsure "Pienso",
   :learner.components.composite.questionnaire.results/view-curriculum
   "Ver plan de estudios",
   :learner.components.composite.questionnaire.results/you-passed
   "Aprobó",
   :learner.components.composite.questionnaire.results/your "Su",
   :learner.components.composite.questionnaire.results/your-answer
   "Su respuesta",
   :learner.components.composite.questionnaire.results/your-confidence
   "Su confianza:",
   :learner.components.composite.questionnaire.tab-navigation/answer-questions
   "Responda las siguientes preguntas.",
   :learner.components.composite.questionnaire.tab-navigation/submit
   "Enviar",
   :learner.components.composite.resource-library/enter-search-term
   "Ingrese el término de búsqueda",
   :learner.components.composite.resource-library/resource-library
   "Biblioteca de recursos",
   :learner.components.composite.resource-library/show-featured
   "Mostrar solo destacados",
   :learner.components.composite.resource-list/download-resource
   "Descargar recurso",
   :learner.components.composite.resource-list/paginated-resources
   "Mostrando de 1 a {paginated-resources} de {resources}",
   :learner.components.composite.resource-list/processing
   "{name} (procesando)",
   :learner.components.composite.resource-list/view-more "Ver más",
   :learner.components.composite.resource-viewer/add-note
   "Agregue su nota",
   :learner.components.composite.resource-viewer/details "Detalles",
   :learner.components.composite.resource-viewer/download-resource
   "Descargar recurso",
   :learner.components.composite.review-mode-buffering/personalizing-activity-review
   "Personalizar la revisión de la actividad…",
   :learner.components.composite.searchable-resource-list/featured-empty-copy
   (icu/msg
    "{displayedResultsCount} {featured, select, true { Destacado} other {}}{resourceCopy}"),
   :learner.components.composite.searchable-resource-list/no-results
   "Sin resultados",
   :learner.components.composite.searchable-resource-list/relates-plural
   " Se relaciona",
   :learner.components.composite.searchable-resource-list/relates-singular
   " Relaciona",
   :learner.components.composite.searchable-resource-list/render-results-catchall
   (icu/msg
    "{displayedResultsCount} {featured, select, true { Destacado} other {}}{resourceCopy}{relateCopy} a '{searchTerm}'"),
   :learner.components.composite.searchable-resource-list/resource-plural
   " Recursos",
   :learner.components.composite.searchable-resource-list/resource-singular
   " Recurso ",
   :learner.components.composite.searchable-resource-list/searching
   "Buscando…",
   :learner.components.composite.take-note-button/add-note
   "Agregar nota",
   :learner.components.composite.user-information-requirements/before-proceeding
   "Antes de continuar, rellene los siguientes datos:",
   :learner.components.composite.user-information-requirements/continue
   "Continuar",
   :learner.components.composite.user-information-requirements/first-name
   "Nombre",
   :learner.components.composite.user-information-requirements/last-name
   "Apellido",
   :learner.components.composite.user-information-requirements/required
   "Obligatorio",
   :learner.components.composite.user-menu/change "Cambiar",
   :learner.components.composite.user-menu/help "Ayuda",
   :learner.components.composite.user-menu/sign-out "Cerrar sesión",
   :learner.components.composite.user-menu/signed-in-as
   "Inició sesión como:",
   :learner.components.composite.user-menu/unspecified "Sin especificar",
   :learner.components.composite.user-note/attached-to "Adjunto a",
   :learner.components.composite.user-note/attached-to-annotation
   "Adjunto a la anotación",
   :learner.components.composite.user-note/attached-to-resource
   "Adjunto al recurso",
   :learner.components.composite.user-note/edit-note "Editar nota",
   :learner.components.composite.user-note/open "Abrir",
   :learner.components.composite.user-note/page-number "Página: {1}",
   :learner.components.composite.user-note/resource-not-found
   "No se pudo encontrar el recurso",
   :learner.components.composite.user-note/taken-at "Tomado a las",
   :learner.components.composite.user-note/updated "Actualizado",
   :learner.components.composite.user-note/video-still
   "Fotograma de video",
   :learner.components.composite.user-note/view-in-document
   "Ver en documento",
   :learner.components.composite.user-note/view-in-video "Ver en video",
   :learner.components.composite.user-note/view-moment "Ver momento",
   :learner.components.composite.user-note/your-note "Su nota",
   :learner.components.forms.active-questionnaire-question/answer-below
   "Responda la pregunta que aparece debajo de esta imagen",
   :learner.components.forms.active-questionnaire-question/skip-for-now
   "Omitir por ahora",
   :learner.components.forms.fields.binary-answer/false "Falso",
   :learner.components.forms.fields.binary-answer/true "Verdadero",
   :learner.components.forms.fields.rating-scale-question/na "N/A",
   :learner.components.forms.note/cancel "Cancelar",
   :learner.components.forms.note/delete "Borrar",
   :learner.components.forms.note/delete-alert
   "¿Seguro que quiere borrar su nota?",
   :learner.components.forms.note/delete-note "Borrar nota",
   :learner.components.forms.note/ignore-changes "Ignorar cambios",
   :learner.components.forms.note/pending-changes "Cambios pendientes",
   :learner.components.forms.note/placeholder
   "Plasme aquí sus pensamientos…",
   :learner.components.forms.note/return-to-note "Regresar a la nota",
   :learner.components.forms.note/save-and-continue
   "Guardar y continuar",
   :learner.components.forms.note/save-note "Guardar nota",
   :learner.components.forms.note/unsaved-alert
   "Tiene cambios sin guardar. ¿Seguro que quiere cerrar su nota?",
   :learner.components.forms.note/update "Actualizar",
   :learner.components.forms.question-base/enter-answer
   "Escriba aquí su respuesta…",
   :learner.components.forms.question-base/guessing "Estoy adivinando",
   :learner.components.forms.question-base/how-confident
   "¿Está seguro de su respuesta?",
   :learner.components.forms.question-base/next "Siguiente",
   :learner.components.forms.question-base/required "Obligatorio",
   :learner.components.forms.question-base/save "Guardar",
   :learner.components.forms.question-base/sure "Estoy seguro",
   :learner.components.forms.question-base/think "Pienso",
   :learner.components.forms.question-base/validate-count
   "Responda a toda la pregunta antes de continuar.",
   :learner.components.forms.question-base/validate-empty
   "La elección no puede estar vacía.",
   :learner.containers.activity/intro-activity-msg
   "Dirigiéndolo a su plan de estudios",
   :learner.containers.activity/media-not-supported
   "Tipo de archivo multimedia no admitido",
   :learner.containers.activity-digest/comprehended "comprendido",
   :learner.containers.activity-digest/digest "resumen",
   :learner.containers.activity-digest/learning-objective-performance
   "Rendimiento del objetivo de aprendizaje",
   :learner.containers.activity-digest/my-activity-digest
   (icu/msg
    "{hasName, select, true {Resumen de la actividad de {name}} other {Resumen de la actividad}}"),
   :learner.containers.activity-digest/no-pinned-content
   "No ancló ningún contenido.",
   :learner.containers.activity-digest/overlooked "pasado por alto",
   :learner.containers.activity-digest/performance-moment-body
   "Los estudiantes con éxito se comprometen, al menos, en un 80 %",
   :learner.containers.activity-digest/performance-moment-description
   "de momentos de aprendizaje",
   :learner.containers.activity-digest/performance-notes-body
   "Los estudiantes con éxito tienen, al menos, 6",
   :learner.containers.activity-digest/performance-notes-description
   "Notas y anclados",
   :learner.containers.activity-digest/performance-percent-body
   (icu/msg
    "Los estudiantes con éxito {isPDF, select, true {leen} other {ven}}, al menos, un 88 %"),
   :learner.containers.activity-digest/performance-percent-description
   (icu/msg
    "del {isPDF, select, true {documento leído} other {video reproducido}}"),
   :learner.containers.activity-digest/performance-user-annotations-body
   "Los estudiantes con éxito tienen, al menos, 4",
   :learner.containers.activity-digest/performance-user-annotations-description
   "Puntos destacados y comentarios",
   :learner.containers.activity-digest/recommended-resources
   "Recursos recomendados",
   :learner.containers.activity-digest/your-activity-performance
   "Rendimiento de su actividad",
   :learner.containers.activity-digest/your-pinned-content
   "Su contenido anclado",
   :learner.containers.activity-questionnaire/continue-evaluation
   "Continuar la evaluación",
   :learner.containers.activity-questionnaire/continue-floating
   "Continuar",
   :learner.containers.activity-questionnaire/continue-post-test
   "Continuar prueba posterior",
   :learner.containers.activity-questionnaire/continue-pre-test
   "Continuar prueba previa",
   :learner.containers.activity-questionnaire/evaluation-contains-results-false
   "Comience la evaluación.",
   :learner.containers.activity-questionnaire/evaluation-contains-results-true
   "Termine la evaluación.",
   :learner.containers.activity-questionnaire/floating-contains-results-false
   "Haga clic en “Iniciar” para empezar.",
   :learner.containers.activity-questionnaire/floating-contains-results-true
   "Haga clic en “Continuar” para reanudar.",
   :learner.containers.activity-questionnaire/post-test-contains-results-false
   "Comience la prueba posterior.",
   :learner.containers.activity-questionnaire/post-test-contains-results-true
   "Finalice la prueba posterior.",
   :learner.containers.activity-questionnaire/pre-test-contains-results-false
   "Realice la prueba previa antes de comenzar esta actividad.",
   :learner.containers.activity-questionnaire/pre-test-contains-results-true
   "Termine la prueba previa antes de comenzar esta actividad.",
   :learner.containers.activity-questionnaire/start-evaluation
   "Comenzar evaluación",
   :learner.containers.activity-questionnaire/start-floating "Comenzar",
   :learner.containers.activity-questionnaire/start-post-test
   "Comenzar prueba posterior",
   :learner.containers.activity-questionnaire/start-pre-test
   "Comenzar prueba previa",
   :learner.containers.activity-readiness-mindset-tool/above-learning-action-threshold
   "Por encima del umbral de acción de aprendizaje",
   :learner.containers.activity-readiness-mindset-tool/above-post-test-reflective-threshold
   "Por encima del umbral reflexivo de la prueba posterior",
   :learner.containers.activity-readiness-mindset-tool/above-pre-test-reflective-threshold
   "Por encima del umbral de reflexión de la prueba previa",
   :learner.containers.activity-readiness-mindset-tool/above-scrubbed-backwards-threshold
   "Por encima del umbral de rebobinado al retroceder",
   :learner.containers.activity-readiness-mindset-tool/assessment-analysis
   "Análisis de evaluación",
   :learner.containers.activity-readiness-mindset-tool/below-learning-action-threshold
   "¿Por debajo del umbral de acción de aprendizaje?",
   :learner.containers.activity-readiness-mindset-tool/below-time-to-complete
   "¿Por debajo del tiempo para terminar?",
   :learner.containers.activity-readiness-mindset-tool/date-started
   "Fecha de inicio: ",
   :learner.containers.activity-readiness-mindset-tool/false "Falso",
   :learner.containers.activity-readiness-mindset-tool/fetch-latest-session-data
   "Obtener los últimos datos de la sesión",
   :learner.containers.activity-readiness-mindset-tool/first-post-test-mastery-score
   "Primera puntuación de dominio de la prueba posterior",
   :learner.containers.activity-readiness-mindset-tool/first-pre-test-mastery-score
   "Primera puntuación de dominio de la prueba previa",
   :learner.containers.activity-readiness-mindset-tool/first-viewed-review-mode
   "Vio por primera vez el modo de revisión",
   :learner.containers.activity-readiness-mindset-tool/high-mindset-flags
   "Indicadores de mentalidad elevada",
   :learner.containers.activity-readiness-mindset-tool/high-mindset-score
   "Puntuación de mentalidad elevada",
   :learner.containers.activity-readiness-mindset-tool/learning-action-count
   "Recuento de acciones de aprendizaje",
   :learner.containers.activity-readiness-mindset-tool/low-mindset-flags
   "Indicadores de mentalidad baja",
   :learner.containers.activity-readiness-mindset-tool/low-mindset-score
   "Puntuación de mentalidad baja",
   :learner.containers.activity-readiness-mindset-tool/mastery-analysis
   "Análisis de dominio",
   :learner.containers.activity-readiness-mindset-tool/meets-high-mindset
   "¿Tiene una mentalidad elevada?",
   :learner.containers.activity-readiness-mindset-tool/meets-low-mindset
   "¿Tiene una mentalidad baja?",
   :learner.containers.activity-readiness-mindset-tool/mindset
   "Mentalidad",
   :learner.containers.activity-readiness-mindset-tool/mindset-analysis
   "Análisis de mentalidad",
   :learner.containers.activity-readiness-mindset-tool/mindset-data
   "Datos de mentalidad",
   :learner.containers.activity-readiness-mindset-tool/no-post-test-reflection
   "¿No hay reflexión de la prueba posterior?",
   :learner.containers.activity-readiness-mindset-tool/not-set
   "No establecido",
   :learner.containers.activity-readiness-mindset-tool/not-set-hyphenated
   "no-establecido",
   :learner.containers.activity-readiness-mindset-tool/not-started
   "no-comenzado",
   :learner.containers.activity-readiness-mindset-tool/not-viewed
   "No revisado",
   :learner.containers.activity-readiness-mindset-tool/plo-analysis
   "Análisis PLO",
   :learner.containers.activity-readiness-mindset-tool/plo-consumed
   "¿PLO consumido?",
   :learner.containers.activity-readiness-mindset-tool/plo-not-consumed
   "¿PLO no consumido?",
   :learner.containers.activity-readiness-mindset-tool/plo-percent-consumed
   "Porcentaje de PLO consumido",
   :learner.containers.activity-readiness-mindset-tool/post-test-reflective-count
   "Recuento reflexivo de la prueba posterior",
   :learner.containers.activity-readiness-mindset-tool/post-test-reflective-threshold
   "Umbral reflexivo de la prueba posterior",
   :learner.containers.activity-readiness-mindset-tool/pre-test-reflective-count
   "Recuento reflexivo de la prueba previa",
   :learner.containers.activity-readiness-mindset-tool/pre-test-reflective-threshold
   "Umbral reflexivo de la prueba previa",
   :learner.containers.activity-readiness-mindset-tool/readiness
   "Disponibilidad",
   :learner.containers.activity-readiness-mindset-tool/revisited-moments
   "¿Momentos revisados?",
   :learner.containers.activity-readiness-mindset-tool/tenuous-mastery-score
   "Puntuación de dominio tenue",
   :learner.containers.activity-readiness-mindset-tool/tenuous-mastery-score-penalty
   "Penalización de puntuación por dominio tenue",
   :learner.containers.activity-readiness-mindset-tool/time-to-complete
   "Hora de finalización (hh:mm:ss)",
   :learner.containers.activity-readiness-mindset-tool/true "Verdadero",
   :learner.containers.activity-results/activity-review-for
   (icu/msg
    "Revisión de la actividad {someGivenName, select, true { para {givenName}} other {}}"),
   :learner.containers.activity-results/activity-stat-consumption "{1}%",
   :learner.containers.activity-results/activity-stat-engaged "{1}%",
   :learner.containers.activity-results/activity-stat-learning-action-details
   "Los estudiantes con éxito tienen, al menos, 6",
   :learner.containers.activity-results/activity-stat-learning-action-title
   (icu/msg
    "Tiene {learningActionCount, plural, =1 {# Nota o anclado} other {# Notas y anclados}}"),
   :learner.containers.activity-results/activity-stat-moment-details
   "Los estudiantes con éxito se comprometen, al menos, en un 80 %",
   :learner.containers.activity-results/activity-stat-moment-title
   "Participó en un {1} % de momentos de aprendizaje",
   :learner.containers.activity-results/activity-stat-read-details
   "Los estudiantes con éxito leen, al menos, el 88 %",
   :learner.containers.activity-results/activity-stat-read-title
   "Leyó un {1} % del documento",
   :learner.containers.activity-results/activity-stat-user-annotation-details
   "Los estudiantes con éxito tienen, al menos, 4",
   :learner.containers.activity-results/activity-stat-user-annotation-title
   (icu/msg
    "Tiene {userAnnotationCount, plural, =1 {# Punto destacado o comentario} other {# Puntos destacados y comentarios}}"),
   :learner.containers.activity-results/activity-stat-watched-details
   "Los estudiantes con éxito vieron, al menos, el 88 %",
   :learner.containers.activity-results/activity-stat-watched-title
   "Vio el {1} % del video",
   :learner.containers.activity-results/claim-credit
   "Asegúrese de reclamar su crédito.",
   :learner.containers.activity-results/completed-activity
   "Completó esta actividad",
   :learner.containers.activity-results/download-digest
   "Descargar el resumen",
   :learner.containers.activity-results/evaluation-label "Evaluación",
   :learner.containers.activity-results/get-credit "Obtener crédito",
   :learner.containers.activity-results/go-home "Ir a inicio",
   :learner.containers.activity-results/learner-engaged-pdf-btn
   "Ver en documento",
   :learner.containers.activity-results/learner-engaged-video-btn
   "Reproducir",
   :learner.containers.activity-results/learning-objective
   "Objetivo de aprendizaje",
   :learner.containers.activity-results/lo-bookmark-amount
   (icu/msg "{bmCount, plural, =1 {# Anclado} other {# Anclados}}"),
   :learner.containers.activity-results/lo-note-amount
   (icu/msg "{noteCount, plural, =1 {# Nota} other {# Notas}}"),
   :learner.containers.activity-results/moment-snapshot-alt
   "Instantánea de un momento",
   :learner.containers.activity-results/no-notes "No tiene notas.",
   :learner.containers.activity-results/no-resources-for-lo
   "No hay recursos relacionados para este objetivo de aprendizaje.",
   :learner.containers.activity-results/notes-sorted-by
   "Las notas se ordenan según la fecha de la última actualización",
   :learner.containers.activity-results/open-link "Abrir ",
   :learner.containers.activity-results/open-resource-lib
   "Abrir biblioteca de recursos",
   :learner.containers.activity-results/pdf-page "Página: {1}",
   :learner.containers.activity-results/please-proceed
   "Proceda al {next-step}",
   :learner.containers.activity-results/please-review-pill "Revise",
   :learner.containers.activity-results/please-review-recommendations
   "Revise sus recomendaciones a continuación.",
   :learner.containers.activity-results/post-test-button-review
   "Revisar prueba posterior",
   :learner.containers.activity-results/post-test-button-take
   "Hacer prueba posterior",
   :learner.containers.activity-results/post-test-learning-objectives-engagement
   "Estuvo muy involucrado con {1} de {2} objetivos de aprendizaje.",
   :learner.containers.activity-results/post-test-label
   "Prueba posterior",
   :learner.containers.activity-results/related-learning-moments
   "Momentos de aprendizaje relacionados",
   :learner.containers.activity-results/related-resources
   "Recursos relacionados",
   :learner.containers.activity-results/review-actions
   "Revise las acciones recomendadas para cada objetivo de aprendizaje.",
   :learner.containers.activity-results/review-label "Revisar",
   :learner.containers.activity-results/review-notes-below
   "Revise sus notas a continuación.",
   :learner.containers.activity-results/revisit
   (icu/msg
    "Puede revisar la actividad {postTestExists, select, true {o el rendimiento de su prueba posterior} other {}}"),
   :learner.containers.activity-results/revisit-activity-btn
   "Revisar actividad",
   :learner.containers.activity-results/take-evaluation-btn
   "Hacer evaluación",
   :learner.containers.activity-results/video-time-concat
   "{start-time-string} - {end-time-string}",
   :learner.containers.activity-results/your-notes "Sus notas",
   :learner.containers.activity-results/your-pins "Su contenido anclado",
   :learner.containers.activity-results/your-recs "Sus recomendaciones",
   :learner.containers.curriculum/activities "Actividades",
   :learner.containers.curriculum/activity " actividad",
   :learner.containers.curriculum/all-resources "Todos los recursos",
   :learner.containers.curriculum/curriculum-complete-text
   "Se completaron todos los pasos necesarios para este plan de estudios",
   :learner.containers.curriculum/curriculum-complete-title
   "Plan de estudios completado.",
   :learner.containers.curriculum/draft "BORRADOR",
   :learner.containers.curriculum/featured-resources
   "Recursos destacados",
   :learner.containers.curriculum/intro "Introducción ",
   :learner.containers.curriculum/matching-resources
   "Recursos complementarios",
   :learner.containers.curriculum/online-curriculum
   "Plan de estudios en línea",
   :learner.containers.curriculum/pdf "PDF",
   :learner.containers.curriculum/published "PUBLICADO",
   :learner.containers.curriculum/resource-library
   "Biblioteca de recursos",
   :learner.containers.curriculum/resume "Reanudar",
   :learner.containers.curriculum/review "Revisar",
   :learner.containers.curriculum/revisit "Revisar",
   :learner.containers.curriculum/start "Comenzar",
   :learner.containers.curriculum/supplemental-activities
   "Actividades opcionales",
   :learner.containers.curriculum/take-evaluation "Hacer evaluación",
   :learner.containers.curriculum/take-post-test
   "Hacer prueba posterior",
   :learner.containers.curriculum/test-out-msg
   "No es necesario en función de su rendimiento en las pruebas previas",
   :learner.containers.curriculum/video "Video",
   :learner.containers.curriculum-registration/additional-info
   "Información adicional",
   :learner.containers.curriculum-registration/cancel "Cancelar",
   :learner.containers.curriculum-registration/continue "Continuar",
   :learner.containers.curriculum-registration/fill-in
   "Antes de continuar, rellene los siguientes datos:",
   :learner.containers.curriculum-registration/first-name "Nombre",
   :learner.containers.curriculum-registration/last-name "Apellido",
   :learner.containers.curriculum-registration/required "Obligatorio",
   :learner.containers.curriculum-registration/select-tag-group
   "Seleccionar un {1}",
   :learner.containers.curriculum-registration/update "Actualizar",
   :learner.containers.curriculum-registration/update-info
   "Actualice la información de su plan de estudios:",
   :learner.containers.curriculum-sign-in/sign-in "Iniciar sesión",
   :learner.containers.download-digest/click-to-download
   "Haga clic en el siguiente vínculo para descargar su resumen",
   :learner.containers.profile/about-you "Acerca de usted",
   :learner.containers.profile/account-overview "Resumen de la cuenta",
   :learner.containers.profile/back-to-activity "Volver a actividad",
   :learner.containers.profile/email "Correo electrónico",
   :learner.containers.profile/email-benefits
   "Los mensajes de correo electrónico que se envíen contribuirán a mejorar y aumentar la experiencia general de aprendizaje.",
   :learner.containers.profile/email-permanence
   "La dirección de correo electrónico asociada a su cuenta no puede modificarse.",
   :learner.containers.profile/email-preferences
   "Preferencias de correo electrónico",
   :learner.containers.profile/email-unsubscribe
   "Cancelar la suscripción de todos los correos electrónicos",
   :learner.containers.profile/sign-out "Cerrar sesión",
   :learner.events.activity/create-note-success-learning-stream
   "Flujo de aprendizaje",
   :learner.events.activity/create-note-success-note "Pestaña de notas",
   :learner.events.activity/create-note-success-predicate
   "Su nota se guardó en ",
   :learner.events.activity/delete-note-success-msg "Nota borrada",
   :learner.events.activity/pin-failure-msg
   "No se pudo anclar el contenido",
   :learner.events.activity/pin-success-msg "Anclado",
   :learner.events.activity/unpin-failure-msg
   "No se puede retirar el anclado",
   :learner.events.activity/unpin-success-msg "Anclado removido",
   :learner.events.activity/update-note-success-msg "Nota actualizada",
   :learner.events.questionnaire/get-questionnaire-failure-msg-body
   "¡Vaya! Parece que no pudimos encontrar el cuestionario que busca.",
   :learner.events.questionnaire/get-questionnaire-failure-msg-confirm
   "Modo de revisión",
   :learner.events.questionnaire/get-questionnaire-failure-msg-title
   "No se encontró el cuestionario",
   :learner.events.questionnaire/question-response-failure-msg
   "Algo salió mal. Intente enviarlo de nuevo.",
   :learner.router.core/activity-loading-msg
   "Espere mientras creamos su actividad",
   :learner.router.core/activity-registration-loading-msg
   "Espere mientras revisamos su inscripción",
   :learner.router.core/curriculum-loading-msg
   "Espere mientras revisamos sus actividades",
   :learner.router.core/curriculum-registration-loading-msg
   "Espere mientras revisamos su inscripción",
   :services.boosts.reengagement/cta-label "Completar aprendizaje",
   :services.boosts.reengagement/name-five-day
   "Cinco días de reactivación",
   :services.boosts.reengagement/name-one-day "Un día de reactivación",
   :services.boosts.reengagement/subject
   "Hay más cosas que aprender: {{activity-name}}",
   :services.boosts.reengagement/title "Complete su aprendizaje",
   :services.email.components.banner/image-alt "Ver actividad",
   :services.email.components.logo/image-alt "Logotipo de la empresa",
   :services.email.components.question/view-questionnaire
   "Ver cuestionario",
   :services.email.containers.boost.core/personalized
   "Esta lista de recursos se personalizó en función de su participación en la actividad. Tómese unos minutos para leerlos.",
   :services.email.containers.boost.core/suggested-resources
   "Recursos recomendados",
   :services.email.containers.boost.stats/activity-consumption-subtitle
   "Revisó {activityConsumption} de {ploType}.",
   :services.email.containers.boost.stats/learning-actions-engaged
   "Realizó {learningActionsEngaged} acciones de aprendizaje.",
   :services.email.containers.boost.stats/moment-consumption-subtitle
   "Participó en {momentConsumption} de los momentos de aprendizaje.",
   :services.email.passwordless/access-attempt
   "Parece que está intentando acceder a ",
   :services.email.passwordless/activity "actividad",
   :services.email.passwordless/admin-app "aplicación de administrador",
   :services.email.passwordless/app "aplicación",
   :services.email.passwordless/button
   (icu/msg
    "Ver {type, select, activity {Actividad} curriculum {Plan de estudios} admin {Aplicación de administrador} other {Aplicación}}"),
   :services.email.passwordless/click-button
   ", haga clic en el botón a continuación.",
   :services.email.passwordless/contact-support
   "Si cree que debería estar registrado, póngase en contacto con el equipo de soporte en: support@archemedx.com",
   :services.email.passwordless/curriculum "plan de estudios",
   :services.email.passwordless/display-name "Iniciar sesión",
   :services.email.passwordless/hello "Hola:",
   :services.email.passwordless/will-expire
   "Este enlace caducará 45 minutos después de su primer clic.",
   :services.email.passwordless/ignore
   "¿No pidió este correo electrónico? Solo ignórelo.",
   :services.email.passwordless/subject
   (icu/msg
    "Listo {admin, select, true {Administrador } other {}}Iniciar sesión"),
   :services.email.passwordless/title "¡Ya casi está!",
   :services.email.passwordless/to-view "Para ver el ",
   :services.email.passwordless/unregistered
   ", pero no parece estar registrado para ello.",
   :test/duplicate "I should not be new"
   :test/icu-plural
   (icu/msg
    "Tengo {count, plural, =0 {cero caramelos} =1 {un caramelo} other {# caramelos}}"),
   :test/inst-fmt
   (inst-fmt
    "{month-numeric-padded}/{day-padded}/{year} {hour12}:{minutes-padded} {dayperiod}")})
